// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  vertical-align: middle;
  --icon-color: #093f22;
}

.row {
  display: flex;
  flex-direction: row;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tag/tag.component.scss"],"names":[],"mappings":"AAAA;EACC,qBAAA;EACA,sBAAA;EAEA,qBAAA;AAAD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AACD","sourcesContent":[":host {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\n\t--icon-color: #093f22;\n}\n.row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
